// extracted by mini-css-extract-plugin
export default {"item":"MenuDropDownItem_item__sIIA1"};